
export default {
  name: 'CardFeature',
  props: {
    cardFeature: {
      type: Object,
      default: () => {},
    },
  },
}
